import { render, staticRenderFns } from "./trainingModulePageDashboardSingle6.vue?vue&type=template&id=58c78e89&scoped=true&"
import script from "./trainingModulePageDashboardSingle6.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageDashboardSingle6.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageDashboardSingle6.vue?vue&type=style&index=0&id=58c78e89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c78e89",
  null
  
)

export default component.exports